import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { timersApi } from "../../imports";
import { msToString } from "../helpers/time";

export default function SpeakerTimer({ cue, cloud, cuePreview = false }) {
	const { projectId } = useParams();
	const [t, setT] = useState();
	const [percentOf, setPercentOf] = useState(100);
	const [colour, setColour] = useState(cue.barColour || "#FFF");

	useEffect(() => {
		let intervalId
		clearInterval(intervalId);

		if (cue.state === "running") {
			intervalId =
				setInterval(() => {
					let now = moment().format("x");
					let diff = cue.endAt - now;
					let percent = (parseInt(diff) / parseInt(cue.duration)) * 100;
					setPercentOf(percent);

					// COLOUR SETTING
					if (diff >= cue.warnOneTime) {
						setColour(cue.barColour || "#FFF");
					} else if (diff <= cue.warnTwoTime) {
						setColour(cue.warnTwoColour);
					} else if (diff <= cue.warnOneTime) {
						setColour(cue.warnOneColour);
					}

					if (diff < 100) {
						switch (cue.onEnd) {
							case "hold":
								timersApi.countdownPause(cue.id, projectId, cue.endAt);
								break;

							case "reset":
								timersApi.countdownReset(cue.id, projectId, cue.duration);
								break;

							default:
								break;
						}
					}
					setT(diff);
				}, 50)
		} else if (cue.state === "reset") {
			setT(cue.duration);
			setPercentOf(100);
			setColour(cue.barColour || "#FFF");
		}

		return () => {
			clearInterval(intervalId);
		};
	}, [cue.barColour, cue.duration, cue.endAt, cue.id, cue.onEnd, cue.state, cue.warnOneColour, cue.warnOneTime, cue.warnTwoColour, cue.warnTwoTime, projectId]);

	if (cuePreview) {
		return <>{msToString(t)}</>;
	}

	return (
		<div className="w-screen h-screen flex flex-col items-center justify-center ">
			{cue.showSpeakerMessage && (
				<span
					className={`key_me p-s4 mb-s4 text-s10xl font-bold font-mono bg-gray-800 rounded-ssm transition-colors
            ${cue.state === "paused" && "animate-pulse"}
            `}
				>
					{cue.speakerMessage}
				</span>
			)}
			<span
				style={{
					color: colour,
				}}
				className={`key_me p-s4 text-s14xl font-bold font-mono bg-gray-800 rounded-ssm transition-colors
            ${cue.state === "paused" && "animate-pulse"}
            `}
			>
				{cue.onEnd === "message" && percentOf < 0
					? cue.endMessage
					: moment
							.duration(t, "milliseconds")
							.format(cue.format || "HH:mm:ss", { trim: cue.trim })}
			</span>
			<div className="key_me mt-s10 w-s9 relative"
				style={{
					transform: cue.trackingDirection === 'left' ? 'scaleX(100%)' : 'scaleX(-100%)'
				}}
			>
				{t > 0 && (
					<div
						style={{
							width: `${Math.min(percentOf, 100) || 100}%`,
							height: "6vh",
							backgroundColor: `${colour}`,
						}}
						className="absolute inset-0 z-10 rounded transition-colors border-[0.5vh]  border-gray-700 border-r-0"
					></div>
				)}
				<div
					style={{
						height: "6vh",
					}}
					className="absolute inset-0 w-s9 bg-transparent z-20 rounded border-[0.5vh] border-gray-700 transition-colors"
				></div>
				{/* Marker One marker */}
				<div
					style={{
						height: "2vh",
						width: "2vh",
						top: "6vh",
						transform: "translateX(-50%)",
						left: `${
							(parseInt(cue.warnOneTime) / parseInt(cue.duration)) * 100
						}%`,
						backgroundColor: `${cue.warnOneColour}`,
					}}
					className="absolute bg-red-300 z-30 mt-s1 rounded-full  transition-colors"
				></div>
				{/* Marker Two marker */}
				<div
					style={{
						height: "2vh",
						width: "2vh",
						top: "6vh",
						transform: "translateX(-50%)",
						left: `${
							(parseInt(cue.warnTwoTime) / parseInt(cue.duration)) * 100
						}%`,
						backgroundColor: `${cue.warnTwoColour}`,
					}}
					className="absolute bg-red-300 z-30 mt-s1 rounded-full  transition-colors"
				></div>
			</div>
		</div>
	);
}
